<template>
   <div class="work-list-desktop">
        <div ref="canvas-container" class="scene-work-container"></div>
   </div>
</template>

<script>

// Scene
import SceneWorkList from '../../helpers/threejs/scenes/SceneWorkList'
import MyEmitter from '../../helpers/MyEmitter'
import params from '../../utils/params'

export default {
    name: "WorkListDesktop",
    props: {
        works: {
            type: Array,
            required: true,
        },
        goBack: {
            type: Function,
        },
    },
    beforeDestroy: function(){
        MyEmitter.off(params.Events.exitWorkListDesktop, this.onExit)
        this.sceneWorkList.destroy()
    },
    mounted: function(){

        // Events
        MyEmitter.on(params.Events.exitWorkListDesktop, this.onExit)

        const hashOnMounted = this.$route.hash.substring(1)
        
        this.sceneWorkList = new SceneWorkList(this.$refs["canvas-container"], {

        }, {
            works: this.works,
            goBack: this.goBack ? this.goBack : undefined, // is optionnel
            pushHash: this.pushHash,
            hashOnMounted: hashOnMounted,
            goToPlayer: this.goToPlayer,
        })
        this.sceneWorkList.init()
        this.sceneWorkList.start()
    },
    methods: {
        onExit: function(onComplete){
            this.sceneWorkList._animateExit(onComplete)
        },

        pushHash: function(nextHash){
            if(nextHash !== this.$router.hash){
                this.$router.push({hash: nextHash})
            }
        },
        
        goToPlayer: function(slug){

            if(slug){
                this.$router.push({
                    name: "player",
                    params: {
                        slug: slug
                    }
                })
            }
        },
    }
}
</script>

<style lang="scss">
    .work-list-desktop{
        position: relative;
        height: 100vh;

        .scene-work-container{
            @include absolute-fullscreen();
        }
    }
</style>